/**
 * Configuración de asesores por nivel educativo.
 * Gaby Silva: maternal, kinder, prefirst
 * Lulú: primaria, secundaria, preparatoria
 */
export const ASESOR_LEVEL_CONFIG = {
  /** Gaby: maternal, kinder, prefirst */
  GABY_EMAILS: [
    "gaby@tepeyac.mx",
  ].map((e) => e.toLowerCase().trim()),

  /** Lulú: primaria, secundaria, preparatoria */
  LULU_EMAILS: [
    "lulu@tepeyac.mx",
  ].map((e) => e.toLowerCase().trim()),

  /** Niveles que atiende Gaby */
  GABY_LEVELS: ["maternal", "kinder", "prefirst"],

  /** Niveles que atiende Lulú */
  LULU_LEVELS: ["primaria", "secundaria", "preparatoria"],
}

const normalizeEmail = (e) => String(e || "").toLowerCase().trim()

export function getAsesorLevelTerritory(email) {
  const e = normalizeEmail(email)
  if (!e) return null
  if (ASESOR_LEVEL_CONFIG.GABY_EMAILS.includes(e)) return "gaby"
  if (ASESOR_LEVEL_CONFIG.LULU_EMAILS.includes(e)) return "lulu"
  return null
}

export function getLevelsForAsesor(email) {
  const territory = getAsesorLevelTerritory(email)
  if (territory === "gaby") return ASESOR_LEVEL_CONFIG.GABY_LEVELS
  if (territory === "lulu") return ASESOR_LEVEL_CONFIG.LULU_LEVELS
  return null
}

/**
 * Dado un nivel educativo, retorna el email de la asesora responsable.
 * Se usa para auto-reasignar cuando cambia el nivel.
 */
export function getAsesorEmailByLevel(nivel) {
  const n = String(nivel || "").toLowerCase().trim()
  if (!n) return null
  if (ASESOR_LEVEL_CONFIG.GABY_LEVELS.includes(n)) return ASESOR_LEVEL_CONFIG.GABY_EMAILS[0]
  if (ASESOR_LEVEL_CONFIG.LULU_LEVELS.includes(n)) return ASESOR_LEVEL_CONFIG.LULU_EMAILS[0]
  return null
}
